import { render, staticRenderFns } from "./vacancies-table-header.vue?vue&type=template&id=19a3b6ac&"
import script from "./vacancies-table-header.vue?vue&type=script&lang=js&"
export * from "./vacancies-table-header.vue?vue&type=script&lang=js&"
import style0 from "./vacancies-table-header.vue?vue&type=style&index=0&id=19a3b6ac&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports